import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofSection() {
  const benefits = ['Confianza', 'Seguridad', 'Control', 'Mejor desempeño'];
  return <section className="relative w-full bg-[#0a0a0a] py-10 md:py-14 overflow-hidden" data-id="element-484">
      <div className="absolute inset-0 z-0" data-id="element-485">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-red-900/10 blur-[120px]" data-id="element-486" />
      </div>

      <div className="relative z-20 max-w-4xl mx-auto px-6 text-center" data-id="element-487">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-488">
          <div className="inline-flex items-center gap-2 bg-red-900/30 border border-red-600/50 text-red-400 px-4 py-1.5 rounded-full text-xs md:text-sm font-bold mb-6 shadow-[0_0_15px_rgba(220,38,38,0.2)]" data-id="element-489">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-490" />
            COMUNIDAD ACTIVA
          </div>

          <h2 className="font-display text-3xl md:text-5xl uppercase mb-8 text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-491">
            Más de <span className="text-red-500" data-id="element-492">1.500 hombres</span> ya han
            comenzado su transformación
          </h2>

          <p className="text-gray-400 text-sm md:text-base uppercase tracking-widest mb-6" data-id="element-493">
            Recuperando:
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-494">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="bg-black/60 backdrop-blur-sm border border-red-900/40 px-5 py-2.5 rounded-lg shadow-[0_0_15px_rgba(220,38,38,0.05)] flex items-center gap-2" data-id="element-495">
                <span className="text-red-500 text-lg drop-shadow-[0_0_6px_rgba(220,38,38,0.5)]" data-id="element-496">
                  ✔
                </span>
                <span className="text-white font-medium" data-id="element-497">{benefit}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}